import React from 'react'
import { Card, Space, Row, Col, Typography, Image, Grid } from 'antd';
import { CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons';
import CorrectKtp from '../../assets/img/document/ktp-correct.png';
import IncorrectKtp from '../../assets/img/document/ktp-incorrect.png';
import { withTranslation } from 'react-i18next';

const { Text } = Typography;
const { useBreakpoint } = Grid;

function GetBreakPoint() {
    const screens = useBreakpoint()
    return screens;
}
  
export function InfoKtp(props) {
    const { xs } = GetBreakPoint()
    const { t } = props
    return (
        <Card className='border-radius-6' bodyStyle={{ padding: xs ? 8 : 32 }}>
            <Row>
                <Col span={24}>
                    <Row>
                        <Col className='text-align-center' span={12}>
                            <Space direction="vertical" size={0}>
                                <CheckCircleFilled className='primary-color fs-28' />
                                <Image src={CorrectKtp} width="100%" height={xs ? 120 : 200} preview={false} style={{ objectFit: 'contain' }} />
                            </Space>
                        </Col>
                        <Col className='text-align-center' span={12}>
                            <Space direction="vertical" size={xs ? 8 : 16}>
                                <CloseCircleFilled className='danger-color fs-28' />
                                <Image src={IncorrectKtp} width="100%" height={xs ? 105 : 170} preview={false} style={{ objectFit: 'contain' }} />
                            </Space>
                        </Col>
                        <Col xs={24} md={12}>
                            <Space direction="vertical" size={0}>
                                <Text type="secondary">{t('profile.document.info.ktp.title')}</Text>
                                <Text type="secondary">• {t('profile.document.info.ktp.first.normal1')}<Text className='dark-color' strong>{t('profile.document.info.ktp.first.bold')}</Text>{t('profile.document.info.ktp.first.normal2')}</Text>
                                <Text type="secondary">• {t('profile.document.info.ktp.second')}</Text>
                                <Text type="secondary">• {t('profile.document.info.ktp.third')}</Text>
                            </Space>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Card>
    )
}

export default withTranslation()(InfoKtp)